import React, { useEffect, useState } from 'react'
import DynamicForm from '../../../yoello-lib/modules/dynamicForms/DynamicForms'
import venueAddressForm from '../../../formSchemas/venueAddress.form'
import { useChangedDialog } from '../../../hooks/useChangedDialog';
import EColourPanel from '../../../interfaces/EColourPanel';
import { useTranslation } from 'react-i18next';
import { useDialogRouteStages } from '../../dialogRoutes/useDialogRouteStages';
import { DELIVERY_URL, dialogKeys } from '../../../const/URL.const';
import { ICallAPIFunction } from '../../../yoello-lib/modules/API2/types';
import { HTTPMethods } from '../../../yoello-lib/modules/API/API';
import ListLoading from '../../util/Loading';
import { FormLoadingWrapper } from '../../util/FormLoadingWrapper';
import { useSelector } from 'react-redux';
import { IReduxAppState } from '../../../reducers';
import { useAPIV2 } from '../../../yoello-lib/modules/API2/useAPIv2';
import APIExtensions from '../../../yoello-lib/modules/API2/APIDefs';

interface IAddressFormState {
  address_apartment: null
  address_building: null
  address_city: string
  address_country: null
  address_number: string
  address_postcode: string
  address_state: null
  address_street: string
  consumer_id: null
  created_on: string
  default: false
  deleted: false
  id: string
  latitude: number
  location_name: string
  location_type: string
  longitude: number
  map_id: any
  metadata_: null
  serial_id: number
  updated_on: string
  venue_id: string
}

interface ISetLocationDialogProps {
  path?: string
  history?: any
  locationCallApi:ICallAPIFunction<any>;
  isLoading?: boolean
  onClose: () => void
}

export default function SetLocationDialog(props: ISetLocationDialogProps) {
  const {path, history, onClose, locationCallApi} = props
  const [state , setState] = useState<IAddressFormState | undefined>(undefined);

  const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);

  const {callAPI, isLoading} = useAPIV2<any>(APIExtensions.venues,{
    query: `${selectedVenueId}/locations`,
  })

  const { t } = useTranslation();
  const { hasFormChanged } = useChangedDialog();


  const { goToNextStep } = useDialogRouteStages(history);

  useEffect(()=>{
    callAPI(HTTPMethods.GET)
      .then((res: any)=>{
        setState({
          ...res?.data?.[0]
        })
      })
      // eslint-disable-next-line
  }, [])

  async function onConfirm(e: any) {
    try {
      if (!state?.address_postcode) {
        await callAPI(HTTPMethods.POST, {
          body: {
            ...e,
            location_name: 'VENUE_PICKUP_ORIGIN',
          }
        })
      }else {
        await callAPI(HTTPMethods.PATCH, {
          body: {
            ...e
          },
          query: `${selectedVenueId}/locations/${state.id}`
        })
      }
      goToNextStep(
        dialogKeys.SELECTONMAP,
        {
          ComponentProps: {
            ...e,
            locationCallApi,
            idid: state?.id
          },
          dialogTitle: t("selectLocation.selectYourLocation"),
        }, `${path}${DELIVERY_URL}/map`, null)
    } catch (error) {
      console.log('location api call', error);
    }
  }
  
  return (isLoading  ? <FormLoadingWrapper><ListLoading/></FormLoadingWrapper> :
    <>
      <DynamicForm
        useFormOptions={{
          mode: "onChange", reValidateMode: "onChange"
        }}
        onHandleSubmit={onConfirm}
        formRows={venueAddressForm()}
        formData={state}
        disableAll={isLoading}
        formKeyName={"set_location"}
        isDialog={true}
        hasDataChanged={hasFormChanged}
        formButtons={{
          leftButton: {
            type: "button",
            label: t("forms.buttons.cancel"),
            color: EColourPanel.DEFAULT,
            fullWidth: false,
            onClick: ()=> onClose?.(),
          },
          rightButton: {
            type: "submit",
            label: t("discounts.buttons.createDiscount"),
            color: EColourPanel.PRIMARY,
            fullWidth: false,
            disabled: false,
            // onClick: onClickSetLocation
          },
        }}
      />
    </>
  )
}
